import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool } from '../../../../helpers/custom-prop-types';
import SearchCardThemeItems from './SearchCardThemeItems';
import SearchCardThemeItemsSkeleton from './SearchCardThemeItemsSkeleton';
const SearchCardTheme = (props) => {
    const { themeList, themeLoading } = props;
    if (!themeLoading && themeList.length === 0) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'card_body_section card_body_section_theme' }, { children: [_jsx("div", Object.assign({ className: 'card_body_section_header' }, { children: _jsx("h4", Object.assign({ className: 'card_body_section_header_label' }, { children: "\u30C6\u30FC\u30DE\u5225\u5BFE\u5FDC\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u6570" })) })), _jsx("div", Object.assign({ className: 'theme_list_box' }, { children: themeLoading && themeList.length === 0 ? (_jsx(SearchCardThemeItemsSkeleton, {})) : (_jsx(SearchCardThemeItems, { themeList: themeList })) }))] })));
};
SearchCardTheme.propTypes = {
    themeList: propArrayShape().isRequired,
    themeLoading: propBool().isRequired,
};
export default SearchCardTheme;
